import { Capacitor } from '@capacitor/core';

const API_BASE_URL = Capacitor.isNativePlatform()
  ? 'https://app.closingdayontario.ca'
  : '';

export function apiUrl(path) {
  return `${API_BASE_URL}${path}`;
}
